import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { getSpacingClasses } from '../../utils/getSpacingClasses';

export default function save({ attributes }) {
  const {
    orientation,
    invertLayout,
    imageURL,
    contentBackgroundColor,
    href, 
    opensInNewTab
  } = attributes;

  const isVertical = orientation === 'vertical';

  // Aggiunto overflow-hidden per il rounding
  const containerClasses = `card-slider no-underline flex ${ isVertical ? invertLayout ? 'flex-col-reverse' : 'flex-col' : invertLayout ? 'flex-col-reverse md:flex-row-reverse' : 'flex-col md:flex-row' } `;

  const imageWrapperClasses = `image_wrapper relative w-full ${isVertical ? '' : 'md:w-1/2'}`;

  const contentWrapperClasses = `mb-auto ${isVertical ? 'w-full' : 'md:w-1/2 w-full'}`;

  const blockProps = useBlockProps.save({
    className: `swiper-slide !h-auto ${getSpacingClasses(attributes)}`,
  });

  return (
    <div {...blockProps}>
      {href ? (
        //Render the link only if href is not empty
        <a 
          href={href || "javascript:void(0)"}
          target={opensInNewTab ? "_blank" : "_self"} // Dynamically set target
          rel={opensInNewTab ? "noopener noreferrer" : undefined} // Add rel for security with _blank
          className={containerClasses}
        >
          {/* Wrapper immagine */}
          <div className={imageWrapperClasses}>
            {imageURL && (
              <img
                src={imageURL}
                alt=""
                className="w-full h-auto"
              />
            )}
          </div>

          {/* Wrapper contenuti */}
          <div
            className={contentWrapperClasses}
            style={
              contentBackgroundColor
                ? { backgroundColor: contentBackgroundColor }
                : {}
            }
          >
            <div>
              <InnerBlocks.Content />
            </div>
          </div>
        </a>
      ) : (
        <div className={containerClasses}>
          {/* Wrapper immagine */}
          <div className={imageWrapperClasses}>
            {imageURL && (
              <img
                src={imageURL}
                alt=""
                className="w-full h-auto"
              />
            )}
          </div>

          {/* Wrapper contenuti */}
          <div
            className={contentWrapperClasses}
            style={
              contentBackgroundColor
                ? { backgroundColor: contentBackgroundColor }
                : {}
            }
          >
            <div>
              <InnerBlocks.Content />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
